// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__17Mhm","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3Jo_R","obliqueLine":"membershipbadge_obliqueLine__3nEwC"};